import { store } from "../redux/store/store";
import { setModal } from "../redux/reducers/showModal";

export const openModal = ({ value }) => {
  store.dispatch(setModal(value));
};
